import classNames from 'classnames';
import { FC, useState } from 'react';

import type { Article, ArticleSubcategory } from '@/entities/article';
import { ArticleCategoryItem } from '@/features/article';

import styles from './articleCategoryList.module.scss';
import ArticleSubCategoryList from '../ArticleSubCategoryList/ArticleSubCategoryList';


interface ArticleCategoryList {
  className?: string;
  value: Article;
  subcategoryDisplayCountById?: Record<number, number>;
}

const ArticleCategoryList: FC<ArticleCategoryList> = (props) => {
  const { className, value, subcategoryDisplayCountById } = props;
  const { name, subcategories } = value;
  const [activeItemId, setActiveItemId] = useState<number>(0);

  function toggleActiveCategory(id: number) {
    setActiveItemId((prev) => (prev === id ? 0 : id));
  }

  function renderCategories(category: ArticleSubcategory, index: number) {
    const isActive = activeItemId === category.id;
    const displayCount =
      subcategoryDisplayCountById?.[category.id] ?? category?.sort_order ?? 0;
    return (
      <li
        key={`category-${category.id}-${index}`}
        className={styles.container__item}
      >
        <ArticleCategoryItem
          displayCount={displayCount}
          isActive={isActive}
          value={category}
          onClick={() => toggleActiveCategory(category.id)}
        />
        <div
          aria-hidden={!isActive}
          className={classNames(
            styles.container__panel,
            isActive && styles.container__panel_open,
          )}
          id={`article-category-${category.id}`}
          inert={!isActive}
        >
          <div className={styles.container__panelContent}>
            <ArticleSubCategoryList
              className={styles.container__subList}
              parentDisplayCount={displayCount}
              value={category.articles}
            />
          </div>
        </div>
      </li>
    );
  }

  return (
    <div className={classNames(className, styles.container)}>
      {!!name && (
        <div className={styles.container__headBlock}>
          <p className={styles.container__head}>{name}</p>
        </div>
      )}
      <ul className={classNames(className, styles.container__list)}>
        {subcategories?.map(renderCategories)}
      </ul>
    </div>
  );
};

export default ArticleCategoryList;
